import React from 'react';
import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import * as Actions from './actions'
import { cloneDeep } from 'lodash';

// Get Applicant status details
export const getApplicantStatus = () => (dispatch, getstate) => {
    dispatch(Actions.isLoading(true))

    const loginData = JSON.parse(localStorage.getItem("publicLoginData"))
    try {
        const id = loginData.ApplicantCode
        const company = loginData.Company
        return ApiService.get(`${Path.STATUS}/${id}/${company}`)
            .then((response) => {
                const { data } = response

                dispatch(Actions.setApplicantStatusData({
                    data: data
                }))
                return response.data;
            })
            .catch((error) => {
                console.error(error)
            }).finally(() => {
                dispatch(Actions.isLoading(false))
            })
    } catch (error) {
        console.error(error)
        dispatch(Actions.isError404(true))
        dispatch(Actions.isLoading(false))
    }
}

export const ApplyLoginData = (name, code, company, companyName) => (dispatch, getstate) => {
    const { loginForm: { alert } } = getstate()
    let nAlert = { ...alert }

    dispatch(Actions.isLoading(true))

    return ApiService.get(`${Path.LOGINROOT}/${name}/${code}/${company}`)
        .then((response) => {
            if (response) {
                let title = `LOGIN SUCCESSFULLY`
                const message = response.data.message
                let show = false
                const formalName = name
                    .toLowerCase()
                    .split(" ")
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ");

                if (response.data.returnCode <= 0) {
                    title = 'LOGIN FAILED'
                    show = true
                }
                else {
                    localStorage.setItem('publicLoginData', JSON.stringify({
                        CompleteName: formalName,
                        ApplicantCode: code,
                        Company: companyName,
                    }));
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: show,
                    content: message,
                }
            }
            return response.data
        })
        .catch((e) => {
            console.error(e)
        })
        .finally(() => {
            dispatch(Actions.isLoading(false))
            dispatch(Actions.updateAlertData(nAlert))
        })
}

export const getCompanyId = (company) => (dispatch, getstate) => {
    dispatch(Actions.isLoading(true))
    return ApiService.get(`${Path.COMPANY}/${company}`)
        .then((response) => {
            localStorage.removeItem('publicLoginData')
            dispatch(Actions.setCompanyId(response.data))
            return response.data
        })
        .catch((error) => {
            console.error(error)
            dispatch(Actions.isError404(true))
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}